import { platformBrowser } from '@angular/platform-browser';
import { AppModule } from './app/app-module';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

platformBrowser()
	.bootstrapModule(AppModule, {})
	.catch((err) => console.error(err));
